import { AndroidOutlined, Apple, Close, HelpOutlineOutlined, LanguageOutlined, MailOutlined } from '@mui/icons-material'
import { Alert, AlertTitle, AppBar, Box, Button, Card, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, TextField, Toolbar, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import NumberFormat from 'react-number-format'
import TimeAgo from 'react-timeago'
import { ApiHelper } from '../Helpers'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
})


export default function Sent(props) {
  const apiHelper = useMemo(() => new ApiHelper(), [])
  const [pageSize, setPageSize] = useState(10)
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [errorState, setErrorState] = useState({
    message: '',
    active: false,
  })
  const [inDialogError, setInDialogError] = useState('')
  const [selectedOrder, setSelectedOrder] = useState("")
  const [actionDrawerState, setActionDrawerState] = useState({
    open: false,
  })
  const [selectedTransitStatus, setselectedTransitStatus] = useState('')
  const [actionProgress, setActionProgress] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [orderResponseMetaData, setOrderResponseMetaData] = useState()
  // const [selectedOrder, setSelectedOrder] = useState("")
  const returnReasonRef = useRef('')
  const deliveredAtRef = useRef(moment(Date.now()).format('YYYY-MM-DDTHH:mm'))

  const columns = [
    {
      field: 'created_at', headerName: 'Order Date', type: 'date', width: 180, renderCell: (cell) => {
        return <div>
          <Typography variant='subtitle2' fontWeight={'bold'}>{moment(cell.value).format('DD-MM-YYYY')}</Typography>
          <Typography variant='caption'><TimeAgo date={cell.value} /> at {moment(cell.value).format('hh:mm A')}</Typography>
        </div>
      }
    },
    {
      field: 'dispatched_at', headerName: 'Dispatch Date', type: 'date', width: 180, renderCell: (cell) => {
        return <div>
          <Typography variant='subtitle2' fontWeight={'bold'}>{moment(cell.value).format('DD-MM-YYYY')}</Typography>
          <Typography variant='caption'><TimeAgo date={cell.value} /> at {moment(cell.value).format('hh:mm A')}</Typography>
        </div>
      }
    },
    {
      field: 'orderid', headerName: 'Order Detail', width: 150, renderCell: (cell) => {
        return <Tooltip title={`${cell.value} - ${cell.row.full_name}`} >
          <div>
            <Typography noWrap variant="body2" fontWeight={'bold'}>
              {cell.value}
            </Typography>
            <Typography variant='subtitle2' noWrap>
              {cell.row.full_name}
            </Typography>
          </div>
        </Tooltip >
      }
    },
    {
      field: 'crmid', headerName: 'CRM Id', width: 130, renderCell: (cell) => {
        return <Tooltip title={cell.value} >
          <Typography variant='subtitle2' noWrap>
            {cell.value}
          </Typography>
        </Tooltip >
      }
    },
    {
      field: 'transit_status', headerName: 'Order Status', width: 120, renderCell: (cell) => {
        if (cell.value === 'In Transit') {
          return <Chip className='text-capitalize' color='warning' label={cell.value?.toLowerCase()} />
        } else if (cell.value === 'Delivered') {
          return <div>
            <Chip className='text-capitalize' color='success' label={cell.value?.toLowerCase()} />
          </div>
        } else if (cell.value === 'Returned') {
          return <Chip className='text-capitalize' color='error' label={cell.value?.toLowerCase()} />
        } else {
          return <Chip className='text-capitalize' color='default' label={cell.value?.toLowerCase()} />
        }
      }
    },
    {
      field: 'courier_provider', headerName: 'Courier Provider', width: 180, renderCell: (cell) => {
        return <Tooltip title={cell.value} >
          <Typography variant='subtitle2' noWrap>
            {cell.value}
          </Typography>
        </Tooltip >
      }
    },
    {
      field: 'tracking_id', headerName: 'Tracking Id', width: 180, renderCell: (cell) => {
        return <Tooltip title={cell.value} >
          <Typography variant='subtitle2' noWrap>
            {cell.value}
          </Typography>
        </Tooltip >
      }
    },
    {
      field: 'payment_status', headerName: 'Payment Status', width: 170, renderCell: (cell) => {
        if (cell.value === "Pending") {
          return <Chip color='warning' label='Pending' />
        } else if (cell.value === "Success") {
          return <Chip color='success' label='Success' />
        } else if (cell.value === "Failed") {
          return <Chip color='error' label='Failed' />
        } else {
          return <Chip color='default' label='Unknown' />
        }
      }
    },
    {
      field: 'order_source_zone', headerName: 'Order Source', width: 170, renderCell: (cell) => {
        console.log(cell.value)
        if (cell.value === "Website") {
          return <Chip color='info' label='Website' icon={<LanguageOutlined />} />
        } else if (cell.value === "Android") {
          return <Chip color='success' label='Android' icon={<AndroidOutlined />} />
        } else if (cell.value === "iOS") {
          return <Chip color='secondary' label='iOS' icon={<Apple />} />
        } else {
          return <Chip color='default' label='Unknown' icon={<HelpOutlineOutlined />} />
        }
      }
    },
    {
      field: 'product_name', headerName: 'Product Name', width: 200, renderCell: (cell) => {
        return <Tooltip title={cell.row.productList[0].short_name}>
          <div>
            <Typography noWrap variant="body2">
              {cell.row.productList[0].short_name}
            </Typography>
            {
              cell.row.product_count > 1 ? <Typography noWrap variant="caption">
                with {cell.row.product_count - 1} other
              </Typography> : null
            }
          </div>
        </Tooltip>
      }
    },
    {
      field: 'total_price', headerName: 'Order Amount', width: 170, type: 'number', renderCell: (cell) => {
        return <NumberFormat displayType='text' value={cell.value} renderText={(value) => <div>
          {/* <Typography variant='body2' noWrap>{value}</Typography> */}
          <Chip className='text-capitalize mt-1' color={cell.row.payment_mode === 'online' ? 'success' : 'secondary'} label={`${value} - ${cell.row.payment_mode}`} />
        </div>} thousandSeparator={true} thousandsGroupStyle='thousand' prefix='₹' />
      }
    },
    {
      field: 'phone', headerName: 'Contact', width: 140, renderCell: (cell) => {
        return <Tooltip title={cell.value}>
          <Typography noWrap variant="body2">
            {cell.value}
          </Typography>
        </Tooltip>
      }
    },
    {
      field: 'state', headerName: 'Destination', width: 170, renderCell: (cell) => {
        return <Tooltip title={`${cell.value} - ${cell.row.pincode}`} >
          <div>
            <Typography noWrap variant="body2" fontWeight={'bold'}>
              {cell.value}
            </Typography>
            <Typography variant='subtitle2' noWrap>
              <MailOutlined fontSize='small' /> {cell.row.pincode}
            </Typography>
          </div>
        </Tooltip >
      }
    },
  ];

  const orderDetailsColumn = [
    {
      field: 'product_image', headerName: 'Image', width: 150, filterable: false, sortable: false, renderCell: (cell) => {
        return <img src={cell.value} alt={cell.row.product_name} className='img-fluid img-thumbnail' style={{
          maxHeight: 60,
          maxWidth: 60
        }} />
      }
    },
    { field: 'product_name', headerName: 'Product Name', flex: 1 },
    {
      field: 'payment_status', headerName: 'Payment Status', width: 170, renderCell: (_) => {
        if (selectedOrder.row.payment_status === "Pending") {
          return <Chip color='warning' label='Pending' />
        } else if (selectedOrder.row.payment_status === "Success") {
          return <Chip color='success' label='Success' />
        } else if (selectedOrder.row.payment_status === "Failed") {
          return <Chip color='error' label='Failed' />
        } else {
          return <Chip color='default' label='Unknown' />
        }
      }
    },
    {
      field: 'item_qty', headerName: 'Item Quantity', width: 180, renderCell: (cell) => {
        return <Chip label={cell.value} color="info" />
      }
    },
    {
      field: 'paid_amount', headerName: 'Paid Amount', width: 180, renderCell: (cell) => {
        const orderData = orders.filter(e => e.orderid === cell.row.orderid).shift();
        return <NumberFormat displayType='text' value={cell.value} renderText={(value) => <div>
          <Chip className='text-capitalize mt-1' color={orderData.payment_mode === 'online' ? 'success' : 'secondary'} label={`${value} - ${orderData.payment_mode}`} />
        </div>} thousandSeparator={true} thousandsGroupStyle='thousand' prefix='₹' />
      }
    },
  ]

  const updateOrderStatus = async () => {
    const deliveredDate = moment(deliveredAtRef.current)
    const reasonForReturn = returnReasonRef.current.trim()
    if (selectedTransitStatus === 'delivered') {
      if (!deliveredDate.isValid()) {
        setInDialogError("A valid delivered date is required!")
        return
      }
    }

    if (selectedTransitStatus === 'returned' && reasonForReturn === '') {
      setInDialogError('Please provide the reason for return!')
      return
    }
    // console.log('Can go ahead')

    setActionDrawerState({ open: false })
    setActionProgress(true)

    const response = await apiHelper.updateSentOrder(selectedOrder.row.orderid, selectedTransitStatus,
      deliveredAtRef.current, returnReasonRef.current.trim());


    if (response.ok) {
      localStorage.setItem('order_room_tab', props.tIndex ?? 0)
      window.location.reload()
    } else {
      setActionProgress(false)
      setInDialogError(response.message)
      setActionDrawerState({
        open: true,
      })
    }

  }

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      const response = await apiHelper.fetchSent(currentPage + 1, pageSize)
      if (response.ok) {
        setOrderResponseMetaData(response.data)
        setOrders(response.data.orders)
        setLoading(false)
      } else {
        setErrorState({
          active: true,
          message: response.message
        })
        setLoading(false)
      }
    }
    getData()
  }, [apiHelper, currentPage, pageSize])

  const openActionDrawer = () => {
    setActionDrawerState({ open: true })
  }


  return (
    <Box>
      {
        loading ? <div className='d-flex justify-content-center mt-5'>
          <CircularProgress />
        </div> : <div className='container-fluid px-5'>
          {
            errorState.active ? <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {errorState.message}
            </Alert> : <Typography variant='subtitle2' className='mt-2 fw-bold text-danger'>*Click anywhere on the order to view details.</Typography>
          }
          <DataGrid
            className='mt-3'
            rows={orders}
            getRowId={e => e.orderid}
            columns={columns}
            autoHeight
            rowHeight={80}
            paginationMode='server'
            rowsPerPageOptions={[10, 30, 50, 70, 100]}
            pageSize={pageSize}
            onPageSizeChange={(e) => setPageSize(e)}
            onPageChange={(e) => {
              setCurrentPage(e)
            }}
            rowCount={orderResponseMetaData.totalData ?? 0}
            page={currentPage}
            onCellClick={(e) => {
              if (['payment_status', 'order_source_zone', 'transit_status', 'total_price'].includes(e.field)) {
                setSelectedOrder(e)
              }
            }}
            // onRowClick={(data) => setSelectedOrder(data)}
            error={errorState.message.length > 0 ? errorState.message : null}
          />
          {/* Order edit dialog */}
          {
            selectedOrder !== "" ? <Dialog
              fullScreen
              open={selectedOrder !== ""}
              // onClose={}
              TransitionComponent={Transition}
            >
              <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={_ => setSelectedOrder("")}
                    aria-label="close"
                  >
                    <Close />
                  </IconButton>
                  <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                    Order Details
                    <Typography variant="subtitle2" color="#fffc" >Order Id: {selectedOrder.row.orderid} | CRM Id: {selectedOrder.row.crmid}</Typography>
                  </Typography>
                  {
                    selectedOrder.row.tracking_link !== null ? <Button href={selectedOrder.row.tracking_link} target="_blank" color="inherit" variant='outlined'>
                      Track Now
                    </Button> : null
                  }
                </Toolbar>
              </AppBar>
              <div className="container mt-5">
                <div className="row">
                  <div className="col-12 col-md-6 p-2">
                    <Card variant="outlined" className='p-2'>
                      <Typography variant='h5'>Ship To</Typography>
                      <Typography>{selectedOrder.row.full_name} - (<a className='text-decoration-none' href={`tel:${selectedOrder.row.phone}`}>{selectedOrder.row.phone}</a>)</Typography>
                      <Typography>
                        {
                          `${selectedOrder.row?.address_line_1 ?? ''}, ${selectedOrder?.row.address_line_2 ?? ""}, ${selectedOrder.row?.city ?? ""}, ${selectedOrder.row?.district ?? ""}, ${selectedOrder.row?.state ?? ""} - ${selectedOrder.row?.pincode ?? ""}`
                        }
                      </Typography>
                    </Card>
                  </div>
                  <div className="col-12 col-md-6 p-2">
                    <Card variant="outlined" className='p-2'>
                      <Typography variant='h5'>Order Information</Typography>
                      Order Amount: <NumberFormat displayType='text' value={selectedOrder.row.total_price} thousandSeparator={true} thousandsGroupStyle='thousand' prefix='₹' />
                      <Typography>Total Items: {selectedOrder.row.productList.length}</Typography>
                      <Typography>Ordered at: {moment(selectedOrder.row.created_at).format('DD/MM/YYYY hh:mm A')}</Typography>
                    </Card>
                  </div>
                  <div className="col-12 col-md-6 p-2">
                    <Card variant="outlined" className='p-2'>
                      <Typography variant='h5'>Tracking Information</Typography>
                      <Typography>Courier Provider: {selectedOrder.row.courier_provider}</Typography>
                      <Typography>Tracking Id: {selectedOrder.row.tracking_id}</Typography>
                      <Typography>Dispatched at: {moment(selectedOrder.row.dispatched_at).format('DD/MM/YYYY hh:mm A')}</Typography>
                      <Typography>Delivered at: {moment(selectedOrder.row.delivered_at).format('DD/MM/YYYY hh:mm A')}</Typography>
                    </Card>
                  </div>
                  <div className="col-12 col-md-6 p-2">
                    <Card variant="outlined" className='p-2'>
                      <Typography variant='h5'>Delivery Information</Typography>
                      {
                        selectedOrder.row.transit_status === 'In Transit' ? <Typography>Order is still in transit</Typography> : null
                      }
                      {
                        selectedOrder.row.transit_status === 'Returned' ? <div>
                          <Typography>Order could not be delivered!</Typography>
                          <Typography>Reason: {selectedOrder.row.dispo_message ?? 'Unknown'}</Typography>
                        </div> : null
                      }
                      {
                        selectedOrder.row.transit_status === 'Delivered' ? <div>
                          <Typography>Delivered at: {moment(selectedOrder.row.delivered_at).format('DD/MM/YYYY hh:mm A')}</Typography>
                        </div> : null
                      }
                    </Card>
                  </div>
                </div>
                <div className='mt-3'>
                  <Typography variant='h5' className='mb-2'>Order Content</Typography>
                  <DataGrid isRowSelectable={_ => false} rowHeight={80} getRowId={e => e.proid} rows={selectedOrder.row.productList} columns={orderDetailsColumn} autoHeight pageSize={10} />
                </div>
                <Divider className='my-4' />
                {
                  selectedOrder.row.transit_status !== 'Delivered' ? <div className='text-center'>
                    {
                      actionProgress ? <CircularProgress /> : <div>
                        {
                          Array.isArray(props.permissions) && props.permissions.includes('order_room_v2_sent_update_transit_status') ? <Button variant='contained' color='primary' className='mx-2' onClick={_ => openActionDrawer()}>Update Transit Status</Button> : null
                        }
                      </div>
                    }

                  </div> : null
                }
              </div>
            </Dialog> : null
          }
          {
            selectedOrder !== '' ? <Dialog open={actionDrawerState.open} onClose={_ => {
              setActionDrawerState({ open: false, type: '' })
              setInDialogError('')
              setselectedTransitStatus('')

            }}>
              <DialogTitle>Update order status</DialogTitle>
              <DialogContent className='mt-2'>
                <FormControl fullWidth className='mt-2'>
                  <InputLabel id="transit-select">Transit Status</InputLabel>
                  <Select
                    labelId="transit-select"
                    value={selectedTransitStatus ?? ''}
                    label="Transit Status"
                    onChange={e => setselectedTransitStatus(e.target.value)}
                  >
                    <MenuItem value='delivered'>Delivered</MenuItem>
                    <MenuItem value='returned'>Returned</MenuItem>
                  </Select>
                </FormControl>
                {
                  selectedTransitStatus === 'delivered' ? <TextField
                    id="datetime-local"
                    label="Delivered At"
                    className='mt-3'
                    type="datetime-local"
                    defaultValue={deliveredAtRef.current}
                    fullWidth
                    onChange={e => deliveredAtRef.current = e.target.value}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  /> : null
                }
                {
                  selectedTransitStatus === 'returned' ? <TextField
                    className='mt-3'
                    // margin="dense"
                    // id="name"
                    onChange={e => returnReasonRef.current = e.target.value}
                    label="Reason for return"
                    fullWidth
                    variant="outlined"
                  /> : null
                }
                {
                  inDialogError !== '' ? <Typography color={'error'} className='mt-2'>{inDialogError}</Typography> : null
                }
              </DialogContent>
              <DialogActions>
                {
                  selectedTransitStatus !== '' ? <Button onClick={_ => {
                    updateOrderStatus()
                  }}>Update</Button> : null
                }
              </DialogActions>
            </Dialog> : null
          }
        </div>
      }
    </Box>
  )
}
